export const preset = {
  breakpoints: ["1080px", "1080px"],
  colors: {
    purple25: "#F5F2FF",
    purple50: "#ECE6FE",
    purple100: "#CCC3FC",
    purple300: "#7C71FC",
    purple400: "#5352FC",
    black800: "#363945",

    primaryText: "#5352FC",
    secondaryBackground: "#F5F2FF",
    primary: "#5352FC",
    black: "#292B30",

    text: "#333333",
    primaryButtonText: "#FAFAFA",
    accent: "#7C71FD",
    background: "#FAFAFA",
    secondary: "#bababa",
    muted: "#f6f6f9",
    gray: "#757575",
    mediumGray: "#616161",
    lightGray: "#E0E0E0",
    darkgray: "#8d8d8d",
    highlight: "hsla(205, 100%, 40%, 0.125)",
    box: "#F1F4F4",
    disabled: "#BDBDBD",
    modes: {
      dark: {
        primaryText: "#CCC3FC",
        secondaryBackground: "#363945",
        primary: "#7C71FC",

        text: "#FAFAFA",
        primaryButtonText: "#FAFAFA",
        accent: "#5352FC",
        background: "#212121",
        secondary: "#bababa",
        muted: "#757575",
        gray: "#bababa",
        darkgray: "#BDBDBD",
        highlight: "hsla(205, 100%, 40%, 0.125)",
        box: "#363945",
        disabled: "#BDBDBD",
      },
    },
  },
  fonts: {
    heading: "Regular",
    regular: "Regular",
    bold: "Bold",
    demiBold: "DemiBold",
    medium: "Medium",
  },
  fontSizes: [12, 14, 16, 18, 20, 24, 28, 32, 48, 64, 96],
  lineHeights: {
    body: 1.5,
    heading: 1.25,
  },
  space: [0, 4, 8, 16, 24, 32, 48, 64],
  letterSpacings: {
    small: "-0.05em",
  },
  sizes: {
    avatar: 48,
  },
  shadows: {
    card: "0 0 4px rgba(0, 0, 0, .125)",
  },
  text: {
    default: {
      color: "text",
      fontFamily: "Regular",
      fontWeight: "500",
      fontSize: [18],
      lineHeight: "20px",
    },
    pageHeader1: {
      variant: "text.default",
      fontWeight: "400",
      fontSize: [20],
      lineHeight: "28px",
      color: "black",
    },
    primary: {
      variant: "text.default",
      color: "primaryText",
      fontWeight: "400",
      fontSize: [16],
    },
    title: {
      fontFamily: "Medium",
      fontSize: [28],
      lineHeight: "42px",
    },
    logo: {
      fontFamily: "DemiBold",
      color: "accent",
      fontSize: [20],
      lineHeight: "28px",
      letterSpacing: "small",
    },
    wallet: {
      fontFamily: "DemiBold",
      color: "accent",
      fontSize: [12],
      lineHeight: "16px",
    },
    account: {
      fontFamily: "DemiBold",
      color: "primary",
      fontSize: [12],
      lineHeight: "16px",
    },
    regular: {
      fontFamily: "Regular",
      fontSize: [18],
      lineHeight: "22px",
      color: "text",
    },
    regularGray: {
      fontFamily: "Regular",
      fontSize: [18],
      lineHeight: "22px",
      color: "darkgray",
    },
    bold: {
      fontFamily: "Bold",
      fontSize: 18,
      lineHeight: "20px",
      color: "text",
    },
    form: {
      fontStyle: "Regular",
      fontSize: [14],
      lineHeight: "16px",
      color: "text",
    },
    subtitle: {
      fontStyle: "DemiBold",
      fontSize: [20, 16],
      lineHeight: ["24px", "20px"],
      letterSpacing: "-0.01rem",
      color: "text",
    },
    tableHeader: {
      color: "accent",
      fontFamily: "Medium",
      fontSize: [14],
      lineHeight: "20px",
    },
    summaryTitle: {
      color: "accent",
      fontFamily: "Medium",
      fontSize: [14],
      lineHeight: "20px",
    },
    largeNumber: {
      fontFamily: "DemiBold",
      fontSize: 24,
      lineHeight: "20px",
      color: "text",
    },
    reallyBigNumber: {
      fontFamily: "DemiBold",
      fontSize: 32,
      lineHeight: "20px",
      color: "text",
    },
  },
  variants: {
    avatar: {
      width: "avatar",
      height: "avatar",
      borderRadius: "circle",
    },
    nav: {
      fontSize: 1,
      fontWeight: "bold",
      display: "inline-block",
      p: 2,
      color: "inherit",
      textDecoration: "none",
      ":hover,:focus,.active": {
        color: "primary",
      },
    },
  },
  select: {
    borderColor: "gray",
    borderWidth: "1.5px",
  },
  input: {
    backgroundColor: "#fff",
    borderColor: "lightGray;",
    borderWidth: "1px",
    padding: "18px 16px",
    borderRadius: "6px",
    fontSize: "18px",
    fontFamily: "Regular",
    lineHeight: "20px",
    outline: "transparent",
    ":focus": {
      backgroundColor: "purple25",
      borderColor: "purple300",
    },
    ":focus-visible": {
      backgroundColor: "purple25",
      borderColor: "purple300",
    },
  },
  box: {
    iconContainer: {
      color: "#7C71FC",
      fontSize: "32px",
      width: "48px",
      height: "48px",
      padding: "0px",
      background: "#F5F2FF",
      borderRadius: "106px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      transition: "background 300ms ease-out",
    },
    label: {
      fontSize: "14px",
      fontWeight: "normal",
      lineHeight: "20px",
      color: "#757575",
      backgroundColor: "none",
      marginBottom: "8px",
    },
    responsiveLabel: {
      variant: "box.label",
      marginBottom: ["2px", "8px", "8px"],
    },
  },
  buttons: {
    primary: {
      ":disabled": {
        color: "muted",
        cursor: "auto",
        bg: "disabled",
      },
      ":hover": {
        bg: "#ECE6FE",
      },
      ":focus": {
        bg: "#ECE6FE",
      },
      transition: "background 300ms ease-out",
      fontFamily: "Medium",
      fontSize: 16,
      fontWeight: 400,
      lineHeight: "22px",
      cursor: "pointer",
      borderRadius: "6px",
      height: ["48px", "36px"],
      color: "#5352FC",
      bg: "#F5F2FF",
      px: 3,
      py: 2,
      display: "flex",
      alignItems: ["center", "flex-start", "flex-start"],
      justifyContent: "center",
    },
    submit: {
      variant: "buttons.primary",
      color: "#fff",
      bg: "#5352FC",
      height: ["48px", "42px"],
      lineHeight: "20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginTop: "4px",
      ":hover": {
        bg: "purple300",
      },
      ":disabled": {
        bg: "#BDBDBD",
        color: "muted",
        cursor: "auto",
        ":hover": {
          bg: "#BDBDBD",
        },
      },
    },
    secondary: {
      variant: "buttons.primary",
      ":disabled": {
        borderColor: "gray",
        color: "gray",
        bg: "transparent",
      },
      color: "primary",
      bg: "transparent",
      border: "1px solid",
      borderColor: "primary",
    },
    link: {
      variant: "buttons.secondary",
      border: "none",
      // color: "gray",
      // bg: "transparent",
    },
    ghost: {
      variant: "buttons.link",
      border: "none",
      bg: "transparent",
      ":hover": {
        bg: "none",
      },
      ":focus": {
        bg: "none",
      },
    },
    done: {
      variant: "buttons.secondary",
      color: "accent",
    },
    switcher: {
      bg: "transparent",
      borderRadius: 0,
      fontFamily: "Regular",
      borderBottom: "2px solid transparent",
      color: "text",
      ":focus": {
        outline: "none",
      },
      cursor: "pointer",
      px: 0,
      py: 1,
      mr: 3,
    },
    switcherSelected: {
      variant: "buttons.switcher",
      borderBottom: "2px solid",
      color: "primaryText",
    },
  },
  badges: {
    interestUp: {
      height: [24],
      fontWeight: 400,
      fontSize: [14],
      lineHeight: "20px",
      color: "#00A571",
      background: "#DCF5EE",
      borderRadius: "60px",
      padding: "2px 14px",
    },
    interestDown: {
      height: [24],
      fontWeight: 400,
      fontSize: [14],
      lineHeight: "20px",
      color: "#f00",
      background: "#ffd2d2",
      borderRadius: "60px",
      padding: "2px 14px",
    },
  },
  styles: {
    root: {
      fontFamily: "Regular",
      lineHeight: "body",
    },
    countdown: {
      width: ["180px", "320px"],
      height: ["180px", "320px"],
      color: "accent",
    },
    a: {
      ":visited": {
        color: "primaryText",
      },
      color: "primaryText",
      cursor: "pointer",
    },
    h1: {
      fontSize: 24,
    },
  },
  flex: {
    centered: {
      justifyContent: "center",
      alignItems: "center",
    },
  },
  cards: {
    home: {
      borderRadius: "16px",
      backgroundColor: "white",
      transition: "background 300ms ease-out",
      [`&:hover`]: {
        background: "#F5F2FF",
      },
    },
    bordered: {
      border: "1px solid #ECE6FE",
      borderRadius: "16px",
      background: "white",
      "> *": {
        padding: "16px",
      },
    },
    primary: {
      padding: 2,
      borderRadius: 4,
      bg: "box",
    },
    compact: {
      padding: 1,
      borderRadius: 2,
      border: "1px solid",
      borderColor: "muted",
    },
    warning: {
      backgroundColor: "secondaryBackground",
      borderRadius: 4,
      color: "primaryText",
      px: 3,
      py: 2,
    },
  },
};

export default preset;
